import React, {useState} from 'react';
import { 
  ArrowLeft, Calendar, Clock, MapPin, Star, Utensils, 
  Camera, Plane, Coffee, Car, Sun, ShieldCheck, 
  ChevronRight, Heart, Share2, Info, TriangleAlert, Image,
} from 'lucide-react';
import Type4FlightDetailsSection from './Type4FlightDetailsSection';
import { getDaysBetweenDatesUTC } from '../../../../../helpers/general';
import FullPageGallery from '../../../../../components/FullPageGallery';

const Type4FullItineraryItemDetails = (props) => {

  const { 
      itineraryTripDays,
      itinerary,
      pageTheme,
      onBack,
  } = props;

  const {
    packageTrendsShowHomePage,
    packageTrendsPageBackground,
    packageTrendsPageCardBackground,
    packageTrendsPagePrimaryColor,
    packageTrendsPageSecondColor,
    packageTrendsPageThirdColor,
    packageTrendsPageFourthColor,
  } = pageTheme;

  const [showGallery, setShowGallery] = useState(false);

  const days = [
    {
      day: 1,
      title: "Arrival & Neon Welcome",
      description: "Land at Narita International and enjoy a private transfer to your boutique hotel in Shinjuku. As night falls, we'll head out for a guided neon walk through the vibrant Golden Gai district.",
      activities: ["Private Airport Transfer", "Golden Gai Food Tour", "Rooftop Welcome Drinks"],
      meals: ["Dinner"],
      icon: <Sun className="text-orange-400" />
    },
    {
      day: 2,
      title: "Tradition Meets Tech",
      description: "Morning visit to the serene Senso-ji Temple followed by a total contrast at the teamLab Borderless digital art museum. We'll end the day with a sushi making masterclass.",
      activities: ["Asakusa Cultural Walk", "teamLab Entry", "Sushi Masterclass"],
      meals: ["Breakfast", "Lunch", "Dinner"],
      icon: <Star className="text-yellow-400" />
    },
    {
      day: 3,
      title: "Fashion & The Famous Crossing",
      description: "Dive into the subcultures of Harajuku, walk the famous Shibuya Crossing, and spend the afternoon exploring the hidden boutiques of Daikanyama.",
      activities: ["Meiji Shrine Visit", "Harajuku Explorer", "Shibuya Sky Observatory"],
      meals: ["Breakfast", "Lunch"],
      icon: <Camera className="text-indigo-400" />
    },
    {
      day: 4,
      title: "Mount Fuji Day Trip",
      description: "A luxury coach ride to the Five Lakes region. If the weather is clear, we'll get unparalleled views of Fuji-san from the Chureito Pagoda.",
      activities: ["Hakone Ropeway", "Lake Ashi Cruise", "Chureito Pagoda Walk"],
      meals: ["Breakfast", "Bento Lunch"],
      icon: <Plane className="text-blue-400" />
    }
  ];

  const styles = {
    hero: {
      height: '60vh',
      position: 'relative',
      overflow: 'hidden',
      background: (itinerary.image ? "none" : "black")
    },
    heroImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    dayCard: {
      backgroundColor: (packageTrendsPageCardBackground || '#ffffff'),
      borderRadius: '1.5rem',
      padding: '2rem',
      border: '1px solid #f1f5f9',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
      marginBottom: '2rem',
      position: 'relative',
    }
  };

  const toggleShowGallery = () => {
    setShowGallery(!showGallery)
  }

  let agent_id="";
  if(localStorage.getItem("agent"))
    agent_id = localStorage.getItem("agent");

  const PRODUCTS_INCLUDED = [];
  const PRODUCT_TYPES = [];
  for(let pd=0;pd<itinerary.products.length;pd++){
    const _prod = itinerary.products[pd];
    PRODUCT_TYPES.push(_prod?.product_type?.trim().toLowerCase());
  }

  const included_products_captions = (itinerary?.included_products_captions || {});
  if(PRODUCT_TYPES.includes("flight"))
    PRODUCTS_INCLUDED.push({ 
      label: 'Flights', 
      icon: <Plane style={{color: packageTrendsPagePrimaryColor}} />, 
      val: (included_products_captions?.flight || 'Incl. Economy') 
    });
  if(PRODUCT_TYPES.includes("hotel"))
    PRODUCTS_INCLUDED.push({ 
      label: 'Hotels', 
      icon: <Coffee style={{color: packageTrendsPagePrimaryColor}} />, 
      val: (included_products_captions?.hotel || '4-5★ Stays') 
    });
  if(PRODUCT_TYPES.includes("rental_car"))
    PRODUCTS_INCLUDED.push({ 
      label: 'Transport', 
      icon: <Car style={{color: packageTrendsPagePrimaryColor}} />, 
      val: (included_products_captions?.rental_car || 'Private') 
    });
  
  // To Do: Next
  PRODUCTS_INCLUDED.push({ 
    label: 'Meals', 
    icon: <Utensils style={{color: packageTrendsPagePrimaryColor}} />, 
    val: (included_products_captions?.meal || 'Daily Breakfast') 
  });

  const DURATION = getDaysBetweenDatesUTC(itinerary.start_date, itinerary.end_date);

  return (
    <div style={{backgroundColor: packageTrendsPageBackground}} className="bg-slate-50 min-h-screen">
      {
        showGallery &&
        <div>
          <FullPageGallery
            photos={[itinerary.image, itinerary.image]}
            toggleShowGallery={toggleShowGallery} 
            title={("Photos of "+itinerary.purpose)}
          />
        </div>
      }
      {/* Hero Section */}
      <div style={styles.hero}>
        <div></div>
        <img src={itinerary.image} style={styles.heroImage} />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent"></div>
        
        {/* Top Actions */}
        <div className="absolute top-6 left-6 right-6 flex items-center justify-between z-10">
          {
            packageTrendsShowHomePage &&
            <div className="flex gap-2" style={{position: "relative"}}>
              {
                onBack &&
                <button 
                  style={{border: "none"}}
                  onClick={onBack}
                  className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center text-white hover:bg-white/40 transition-all"
                >
                  <ArrowLeft size={20} />
                </button>
              }
              <button 
                  style={{border: "none"}}
                   onClick={toggleShowGallery}
                  className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center text-white hover:bg-white/40 transition-all"
                >
                  <Image size={20} />
                </button>
            </div>
          }
          <div className="flex gap-2 hidden">
            <button style={{border: "none"}}
                className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center text-white hover:bg-white/40 transition-all">
              <Heart size={20} />
            </button>
            <button style={{border: "none"}}
                className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center text-white hover:bg-white/40 transition-all">
              <Share2 size={20} />
            </button>
          </div>
        </div>

        {/* Hero Text */}
        <div className="absolute bottom-12 left-6 right-6 max-w-7xl mx-auto">
          <div className="flex items-center gap-2 mb-4">
            <span style={{backgroundColor: packageTrendsPagePrimaryColor}} className="bg-indigo-600 text-white text-[10px] font-black uppercase tracking-widest px-3 py-1 rounded-full">
              {(itinerary.short_tag || "No Tag")}
            </span>
            <div className="flex items-center gap-1 text-yellow-400">
              <Star size={14} fill="currentColor" />
              {/*<Star size={14} fill="currentColor" />
              <Star size={14} fill="currentColor" />
              <Star size={14} fill="currentColor" />
              <Star size={14} fill="currentColor" />*/}
              <span style={{color: packageTrendsPageSecondColor}} className="text-white text-xs font-bold ml-1">
                {itinerary?.rating || "N/A"} ({"No reviews"})
                {/*4.9 (120 reviews)*/}</span>
            </div>
          </div>
          <h1 onBlur={()=>{}/*salutationOnInput*/}
              dangerouslySetInnerHTML={{ __html: (itinerary.purpose || "Add Itinerary Title Here") }}
              style={{color: packageTrendsPageSecondColor}} className="text-4xl md:text-6xl font-black text-white mb-4 leading-tight">
          </h1>
          <div className="flex items-center gap-6 text-white/80">
            <div className="flex items-center gap-2">
              <MapPin style={{color: packageTrendsPagePrimaryColor}} size={18} className="text-indigo-400" />
              <span style={{color: packageTrendsPageSecondColor}} className="text-sm font-bold">{itinerary.destination}</span>
            </div>
            <div className="flex items-center gap-2">
              <Calendar style={{color: packageTrendsPagePrimaryColor}} size={18} className="text-indigo-400" />
              <span style={{color: packageTrendsPageSecondColor}} className="text-sm font-bold">
                {
                  isNaN(DURATION) ? <>
                    <span style={{fontSize: 12}}>0 Days</span>
                  </> :
                  <>
                    {
                      DURATION
                    } Days
                  </>
                }
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          
          {/* Main Content */}
          <div className="lg:col-span-2">
            {/* Vibe Section */}
            <div className="mb-12">
              <h2 dangerouslySetInnerHTML={{ __html: itinerary?.description_section_title }} style={{color: (packageTrendsPageThirdColor+"E6")}} className="text-2xl font-black text-slate-900 mb-4">
                </h2>
              <p dangerouslySetInnerHTML={{ __html: itinerary?.description }}
                style={{color: (packageTrendsPageThirdColor+"99")}} className="text-slate-600 font-medium leading-relaxed text-lg">
              </p>
            </div>

            {/* Inclusions Row */}
            <div style={{marginBottom: 5}} className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
              {
              PRODUCTS_INCLUDED.map((item, i) => (
                <div style={{backgroundColor: packageTrendsPageCardBackground}} key={i} className="bg-white p-4 rounded-2xl border border-slate-100 flex flex-col items-center text-center">
                  <div style={{backgroundColor: packageTrendsPageBackground}} className="w-10 h-10 rounded-full bg-slate-50 text-indigo-600 flex items-center justify-center mb-2">
                    {item.icon}
                  </div>
                  <p dangerouslySetInnerHTML={{ __html: (item.label) }}
                    style={{color: (packageTrendsPageThirdColor+"66")}} className="text-[10px] font-black text-slate-400 uppercase tracking-widest"></p>
                  <p dangerouslySetInnerHTML={{ __html: (item.val) }} style={{color: (packageTrendsPageThirdColor+"E6")}} className="text-xs font-bold text-slate-900"></p>
                </div>
              ))}
            </div>

            {/* Flight Details */}
            {
              (Array.isArray(itinerary?.included_flights) && itinerary?.included_flights?.length>0) &&
                <Type4FlightDetailsSection
                  itinerary={itinerary}
                  pageTheme={pageTheme}
                />
            }

            {/* Itinerary Timeline */}
            <div>

              {
                (itineraryTripDays.length>0) ?
                <h2 style={{color: (packageTrendsPageThirdColor+"E6"), marginTop: ((itinerary?.included_flights?.length > 0) ? 0 : 40)}} className="text-2xl font-black text-slate-900 mb-8 flex items-center gap-3">
                  <Clock style={{color: packageTrendsPagePrimaryColor}} size={24} className="text-indigo-600" />
                  <span onBlur={()=>{}/*salutationOnInput*/}
                      dangerouslySetInnerHTML={{ __html: (itinerary?.designer_plus_labels?.timeline_section_title || "Your Day-by-Day Journey") }}
                      contentEditable="true" zIndex="0"></span>
                </h2> : <div style={{padding: 20, backgroundColor: "rgba(60, 0, 0, 1)", display: "flex"}}>
                    <p style={{marginRight: 20, color: "yellow", fontSize: 13}}><i className='fa-solid fa-exclamation-triangle'></i></p>
                    <p style={{color: "white", fontSize: 13}}>No date added to any itinerary item</p>
                </div>
              }
              
              <div className="space-y-4">
                {
                  itineraryTripDays.map((each)=>{
                    const {
                      number,
                      title,
                      icon,
                      date,
                      description,
                      meals,
                    } = each;

                    const _itin_products = itinerary?.products;
                    let activities = [];
                    for(let h=0;h<_itin_products?.length;h++){
                      const _prod = _itin_products[h];
                      const _items = _prod.items;
                      for(let it=0;it<_items.length;it++){
                        let _itm = _items[it];
                        if(_itm?.date===date){
                          if(_prod?.product_type==="flight"){
                            const {
                              departure_airport,
                              arrival_airport,
                            } = _itm;
                            activities.push(`Fight: ${departure_airport} - ${arrival_airport}`);
                          }else if(_prod?.product_type==="hotel"){
                            const {
                              name
                            } = _itm;
                            activities.push(`Hotel Checkin: ${name}`);
                          }else if(_prod?.product_type==="rental_car"){
                            const {
                              company
                            } = _itm;
                            activities.push(`Rental Car: ${company}`);
                          } else if(_prod?.product_type==="event"){
                            const {
                              topic
                            } = _itm;
                            activities.push(`Trip Event: ${topic}`);
                          } // Next Here
                    
                        }
                      }
                    }

                    return <div key={number} style={styles.dayCard} className="group">
                      <div className="flex items-start gap-6">
                        <div className="shrink-0 flex flex-col items-center">
                          <div dangerouslySetInnerHTML={{ __html: number }} style={{color: packageTrendsPageSecondColor}} className="w-12 h-12 rounded-2xl bg-slate-900 text-white flex items-center justify-center font-black text-lg mb-2">
                          </div>
                          <div className="w-0.5 flex-1 bg-slate-100 group-last:hidden"></div>
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-3 mb-2">
                            <h3 dangerouslySetInnerHTML={{ __html: title }} style={{color: (packageTrendsPageThirdColor+"E6")}} className="text-xl font-black text-slate-900"></h3>
                            <span style={{fontSize: 12}}>{date}</span>
                            <Sun className="text-orange-400" />
                          </div>
                          <p onBlur={()=>{}/*salutationOnInput*/}
                              dangerouslySetInnerHTML={{ __html: description }}
                              contentEditable="true" zIndex="0" style={{color: (packageTrendsPageThirdColor+"80")}} className="text-slate-500 font-medium leading-relaxed mb-6">
                          </p>
                          
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                              <p dangerouslySetInnerHTML={{ __html: (itinerary?.designer_plus_labels?.day_highlights_title || "Today's Highlights") }}
                                style={{color: (packageTrendsPageThirdColor+"66")}} className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-3"></p>
                              <ul className="space-y-2">
                                {activities.map((act, idx) => (
                                  <li key={idx} style={{color: (packageTrendsPageThirdColor+"E6")}} className="flex items-center gap-2 text-xs font-bold text-slate-700">
                                    <div style={{backgroundColor: packageTrendsPagePrimaryColor}} className="w-1 h-1 bg-indigo-600 rounded-full"></div>
                                    <span style={{fontSize: 13}} dangerouslySetInnerHTML={{ __html: act }}></span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                            {
                              (meals.length > 0) &&
                              <div style={{backgroundColor: packageTrendsPageBackground}} className="bg-slate-50 p-4 rounded-xl">
                                <p style={{color: (packageTrendsPageThirdColor+"66")}} className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-3">
                                  {(itinerary?.designer_plus_labels?.meals_section_title || "Meals Included")}</p>
                                <div className="flex flex-wrap gap-2">
                                  {meals.map((meal, idx) => (
                                    <span dangerouslySetInnerHTML={{ __html: meal }} key={idx} style={{backgroundColor: packageTrendsPageCardBackground, color: (packageTrendsPageThirdColor+"E6")}} className="bg-white border border-slate-200 text-[10px] font-bold px-2 py-1 rounded-md text-slate-600">
                                    </span>
                                  ))}
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  })
                }
                {/*days*/[].map((day) => (
                  <div key={day.day} style={styles.dayCard} className="group">
                    <div className="flex items-start gap-6">
                      <div className="shrink-0 flex flex-col items-center">
                        <div onBlur={()=>{}/*salutationOnInput*/}
                            dangerouslySetInnerHTML={{ __html: day.day }}
                            contentEditable="true" zIndex="0" style={{color: packageTrendsPageSecondColor}} className="w-12 h-12 rounded-2xl bg-slate-900 text-white flex items-center justify-center font-black text-lg mb-2">
                        </div>
                        <div className="w-0.5 flex-1 bg-slate-100 group-last:hidden"></div>
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center gap-3 mb-2">
                          <h3 onBlur={()=>{}}
                            dangerouslySetInnerHTML={{ __html: day.title }}
                            contentEditable="true" zIndex="0" style={{color: (packageTrendsPageThirdColor+"E6")}} className="text-xl font-black text-slate-900"></h3>
                          {day.icon}
                        </div>
                        <p onBlur={()=>{}/*salutationOnInput*/}
                            dangerouslySetInnerHTML={{ __html: day.description }}
                            contentEditable="true" zIndex="0" style={{color: (packageTrendsPageThirdColor+"80")}} className="text-slate-500 font-medium leading-relaxed mb-6">
                        </p>
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <div>
                            <p dangerouslySetInnerHTML={{ __html: (itinerary?.designer_plus_labels?.day_highlights_title || "Today's Highlights") }}
                              style={{color: (packageTrendsPageThirdColor+"66")}} className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-3"></p>
                            <ul className="space-y-2">
                              {day.activities.map((act, idx) => (
                                <li key={idx} style={{color: (packageTrendsPageThirdColor+"E6")}} className="flex items-center gap-2 text-xs font-bold text-slate-700">
                                  <div style={{backgroundColor: packageTrendsPagePrimaryColor}} className="w-1 h-1 bg-indigo-600 rounded-full"></div>
                                  <span onBlur={()=>{}/*salutationOnInput*/}
                                    dangerouslySetInnerHTML={{ __html: act }}
                                    contentEditable="true" zIndex="0" ></span>
                                </li>
                              ))}
                            </ul>
                          </div>
                          {
                            (day.meals.length > 0) &&
                            <div style={{backgroundColor: packageTrendsPageBackground}} className="bg-slate-50 p-4 rounded-xl">
                              <p style={{color: (packageTrendsPageThirdColor+"66")}} className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-3">
                                {(itinerary?.designer_plus_labels?.meals_section_title || "Meals Included")}</p>
                              <div className="flex flex-wrap gap-2">
                                {day.meals.map((meal, idx) => (
                                  <span dangerouslySetInnerHTML={{ __html: meal }}
                                      contentEditable="true" zIndex="0" key={idx} style={{backgroundColor: packageTrendsPageCardBackground, color: (packageTrendsPageThirdColor+"E6")}} className="bg-white border border-slate-200 text-[10px] font-bold px-2 py-1 rounded-md text-slate-600">
                                  </span>
                                ))}
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Sticky Sidebar */}
          <div className="lg:col-span-1">
            <div className="sticky top-24">
              <div style={{backgroundColor: packageTrendsPageCardBackground}} className="bg-white rounded-3xl p-8 border border-slate-200 -shadow-2xl -shadow-indigo-100">
                <div className="mb-6">
                  <span style={{color: (packageTrendsPageThirdColor+"66")}} className="text-xs font-black text-slate-400 uppercase tracking-widest block mb-1">
                    {(itinerary?.designer_plus_labels?.price_section_title || "Starting From")}</span>
                  <div className="flex items-baseline gap-2">
                    <h3 style={{color: (packageTrendsPageThirdColor+"E6")}} className="text-4xl font-black text-slate-900">{(itinerary.price || "0.00")}</h3>
                    <span dangerouslySetInnerHTML={{ __html: (itinerary?.designer_plus_labels?.price_sub_label || "/ person") }}
                      style={{color: (packageTrendsPageThirdColor+"80")}} className="text-slate-500 font-bold"></span>
                  </div>
                </div>

                <div className="space-y-4 mb-8">
                  <div style={{backgroundColor: packageTrendsPageBackground}} className="flex items-center justify-between p-4 bg-slate-50 rounded-2xl border border-slate-100">
                    <div className="flex items-center gap-3">
                      <ShieldCheck style={{color: packageTrendsPagePrimaryColor}} className="text-indigo-600" size={18} />
                      <span dangerouslySetInnerHTML={{ __html: (itinerary?.designer_plus_labels?.price_section_promise || "Flexible Booking") }}
                          style={{color: (packageTrendsPageThirdColor+"B3")}} className="text-sm font-bold text-slate-700">
                        </span>
                    </div>
                    <Info style={{color: packageTrendsPagePrimaryColor}} size={14} className="text-slate-300" />
                  </div>
                  {
                    PRODUCT_TYPES.includes("flight") && (
                    <div style={{backgroundColor: packageTrendsPageBackground}} className="flex items-center justify-between p-4 bg-slate-50 rounded-2xl border border-slate-100">
                      <div className="flex items-center gap-3">
                        <Plane style={{color: packageTrendsPagePrimaryColor}} className="text-indigo-600" size={18} />
                        <span dangerouslySetInnerHTML={{ __html: (itinerary?.designer_plus_labels?.price_section_flights_caption || "Flights Included") }}
                          style={{color: (packageTrendsPageThirdColor+"B3")}} className="text-sm font-bold text-slate-700"></span>
                      </div>
                      <Info style={{color: packageTrendsPagePrimaryColor}} size={14} className="text-slate-300" />
                    </div>)
                  }
                </div>
                {
                  itinerary?.package_id ?
                  <a href={(window.location.origin+"/deals?ag="+agent_id+"&dlid="+itinerary?.package_id)}>
                    <button style={{border: "none", backgroundColor: packageTrendsPagePrimaryColor, color: packageTrendsPageSecondColor}}
                      className="w-full bg-indigo-600 text-white py-5 rounded-2xl font-black text-lg shadow-xl -shadow-indigo-200 hover:bg-indigo-700 hover:scale-[1.02] active:scale-95 transition-all flex items-center justify-center gap-3 mb-6"
                    >
                      <span dangerouslySetInnerHTML={{ __html: (itinerary?.checkout_button_text || "Secure Your Spot") }}></span> <ChevronRight size={20} />
                    </button>
                  </a> : <div style={{padding: 20, marginBottom: 20, backgroundColor: "rgba(255,0,0,0.1)", color: "red", display: "flex"}}>
                    <TriangleAlert size={25} style={{marginBottom: -5, color: "red", marginRight: 10}} />
                    <span style={{fontSize: 13, color: "red"}}>
                      Checkout not available for this itinerary.</span>
                  </div>
                }
                <p onBlur={()=>{}/*salutationOnInput*/}
                    dangerouslySetInnerHTML={{ __html: (
                      itinerary?.designer_plus_labels?.price_section_policy_note ||
                      "* Price based on double occupancy. Solo traveler supplement may apply. Cancellation policy applies.") }}
                    contentEditable="true" zIndex="0" style={{color: (packageTrendsPageThirdColor+"66")}} className="text-[10px] text-center text-slate-400 font-medium leading-relaxed">
                </p>
              </div>

              {/* Trust Badge */}
              {
                itinerary?.quality_assurance?.show &&
                <div className="mt-6 p-6 bg-slate-900 rounded-3xl text-white">
                  <div className="flex items-center gap-4 mb-4">
                    <div style={{backgroundColor: packageTrendsPagePrimaryColor, color: packageTrendsPageSecondColor}} className="w-10 h-10 rounded-full bg-indigo-600 flex items-center justify-center">
                      <ShieldCheck size={20} />
                    </div>
                    <p dangerouslySetInnerHTML={{ __html: (itinerary?.quality_assurance?.title || "Quality Guarantee Notice") }}
                        style={{color: packageTrendsPageSecondColor}} className="text-xs font-bold leading-tight"></p>
                  </div>
                  <p dangerouslySetInnerHTML={{ __html: (itinerary?.quality_assurance?.description || "We verify every hotel and partner. If your experience doesn't meet the standard, we'll make it right or refund you.") }}
                        style={{color: (packageTrendsPageSecondColor+"80")}} className="text-[10px] text-slate-400 leading-relaxed">
                  </p>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Type4FullItineraryItemDetails;